import './App.css';
import React, { useState, useEffect } from 'react';
import Navbar from './Components/navbar/Navbar';
import Main from './Components/main/Main';
import Table from './Components/table/Table';
import Form from './Components/Form/Form';
import { BrowserRouter, Route, Routes } from "react-router-dom"
import AllOptions from './Components/AllOptions';
import Pagination from './Components/Pagination';
import Sidebar from './Components/sidebar/Sidebar'
import NewTable from './Components/NewTable';
import Login from './Components/Auth/Login';
import { useTranslation } from "react-i18next";
import Categories from './Components/Categories/Categories';
import CategoryAds from './Components/CategoryAds/CatergoryAds';
import MainAds1 from './Components/MainAds/MainAds';
import AllUsers from './Components/Auth/AllUsers';
import Packages from './Components/Packages/Packages';
import SubCategory from './Components/SubCategory/SubCategory';
import AddVen from './Components/Vendors/AddVen';
import Vendors1 from './Components/Vendors/Vendors';
import VendorDetails from './Components/Vendors/VendorDetails';
import Banner from './Components/Banner/Banner';
import ShowFeatures from './Components/Packages/ShowFeatures';
import SocialMedia from './Components/Socail_Media/SocialMedia';
import Setting from './Components/Setting/Setting';
import Stories from './Components/Stories/Stories';
import Reviews from './Components/Reviews/Reviews';
import StoryDetails from './Components/Stories/StoryDetails';
import Reels from './Components/Reels/Reels';
import Editven from './Components/Vendors/Editven';

const App = () => {
  let langLocal = localStorage.getItem('absherLang');
  const [t, i18n] = useTranslation();
  useEffect(() => {
    i18n.changeLanguage(localStorage.getItem('absherLang'));
  }, []);
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const openSidebar = () => {
    setSidebarOpen(true);
  }
  const closeSidebar = () => {
    setSidebarOpen(false);
  }
  let token = localStorage.getItem("tokenA");

  return (
    <>
      {
        token == null ? (
          <BrowserRouter>
            <Routes>
              <Route exact path="/" element={<Login />} />
            </Routes>
          </BrowserRouter>
        ) : (
          <div className={langLocal == "ar" ? "container_ar" : "container_en"}>
            <BrowserRouter>
              <Navbar sidebarOpen={sidebarOpen} openSidebar={openSidebar} />
              <Routes>
                <Route exact path="/" element={<Main />} />
                <Route exact path="/categories" element={<Categories />} />
                <Route exact path="/category-ads" element={<CategoryAds />} />
                <Route exact path="/main-ads" element={<MainAds1 />} />
                <Route exact path="/users" element={<AllUsers />} />
                <Route exact path="/packages" element={<Packages />} />
                <Route exact path="/form" element={<Form />} />
                <Route exact path="/sub-category" element={<SubCategory />} />
                <Route exact path="/vendors" element={<Vendors1 />} />
                <Route exact path="/banner" element={<Banner />} />
                <Route exact path="/add-vendor" element={<AddVen />} />
                <Route exact path="/edit-vendor/:id" element={<Editven />} />
                <Route exact path="/vendor-details/:id" element={<VendorDetails />} />
                <Route exact path="/features/:id/:name" element={<ShowFeatures />} />
                <Route exact path="/social-media" element={<SocialMedia />} />
                <Route exact path="/settings" element={<Setting />} />
                <Route exact path="/stories" element={<Stories />} />
                <Route exact path="/reviews" element={<Reviews />} />
                <Route exact path="/reels" element={<Reels />} />
                <Route exact path="/stories/:id" element={<StoryDetails />} />
              </Routes>
              <Sidebar sidebarOpen={sidebarOpen} closeSidebar={closeSidebar} />
            </BrowserRouter>
          </div>
        )
      }

    </>
  );
}

export default App;
